// PRODUCTION — live-updates section for a single changed config (step group).
import React, { memo } from 'react'
import tw from 'twin.macro'
import { Typography } from '@mui/material'
import type { CollectDataTemplatePreviewConfigEntry } from 'src/interfaces/collectDataTemplatePreview'
import { ChangeChip } from './ChangeChip'
import { OutcomeList } from './OutcomeList'
import { StepCard } from './StepCard'

interface ConfigSectionProps {
  config: CollectDataTemplatePreviewConfigEntry
}

const ConfigSectionComponent = ({ config }: ConfigSectionProps) => {
  return (
    <div css={tw`flex flex-col gap-2.5`}>
      <div css={tw`flex items-center justify-between gap-2`}>
        <Typography variant="h6" css={tw`text-shades-900`}>
          {config.configLabel}
        </Typography>
        <div css={tw`flex-shrink-0`}>
          <ChangeChip changeType={config.configChangeType} />
        </div>
      </div>

      <OutcomeList changes={config.configChanges} />

      {config.steps.map((step) => {
        return <StepCard key={`${step.stepType}-${step.stepLabel}`} step={step} />
      })}
    </div>
  )
}

export const ConfigSection = memo(ConfigSectionComponent)
